import TranslationModal from './TranslationModal';

export default TranslationModal;
